import { render, staticRenderFns } from "./Prediction.icon.vue?vue&type=template&id=61111a9e&"
import script from "./Prediction.icon.vue?vue&type=script&lang=js&"
export * from "./Prediction.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports